import { Box, BoxProps, loaderIcon } from '@ytl/common-web';

import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';

export const BorgMigration = () => {
  const { error } = useOpenAm();
  const { translation } = useLanguage();

  const boxConfig = {
    ...loaderIcon,
    header: translation.borgMigration.header,
    subHeader: translation.borgMigration.subHeader,
    className: 'box__borgmigration',
  } as BoxProps;

  return (
    <>
      <div className="login-page__wrapper">
        <div className="login-page__container login-page__container--center">
          <div className={`login-page__container__box ${error ? 'login-page__container__box--error-view' : ''}`}>
            <Box {...boxConfig} />
          </div>
        </div>
      </div>
    </>
  );
};
